
import { defineComponent, ref, nextTick } from 'vue';
import { message } from 'ant-design-vue';
import { useStore } from 'vuex';
import { request, useFetchAbleRef } from '@/utils/request';
import { createApiUrl, firstError, isValidateError } from '@/utils/utils';
import type { TableColumn } from '@/components/Table';
import '@amap/amap-jsapi-types';
import { formatDate } from '@/core/filters';

export default defineComponent({
  name: 'AddressEditorModal',
  emits: ['complete'],
  setup(props, ctx) {
    const store = useStore();
    const visible = ref(false);

    let map: AMap.Map;
    let driving: any;
    const detailData = ref<any>({});

    const tableColumns: TableColumn[] = [
      { title: '打点', dataIndex: 'point', customRender: ({ text }) => text || '---', width: 120 },
      { title: '位置信息', dataIndex: 'gasName', customRender: ({ text }) => text || '---' },
      { title: '打点时间', dataIndex: 'pointTime', customRender: ({ text }) => formatDate(text), width: 180 },
      { title: '里程(公里)', dataIndex: 'distance', customRender: ({ text }) => text || '---', width: 120 },
    ];

    /** --------------------------------------------------------------------操作按钮---------------------------------------------------------------- */
    const onCancel = () => {
      visible.value = false;
      map && map.destroy();
    };

    const drawMap = () => {
      visible.value = true;

      try {
        nextTick(async () => {
          map = new AMap.Map('mapContainer', {
            zoom: 11, // 级别
            center: [116.397514, 39.907749], // 中心点坐标
            viewMode: '3D', // 使用3D视图
          });

          AMap.plugin('AMap.Driving', () => {
            driving = new AMap.Driving({ map, policy: AMap.DrivingPolicy.LEAST_TIME });
            const { pointData } = detailData.value;
            driving.search(
              [pointData[0].lng, pointData[0].lat],
              [
                pointData[pointData.length - 1].lng,
                pointData[pointData.length - 1].lat,
              ],
              { waypoints: pointData.slice(1, pointData.length - 1).map((i: any) => ([i.lng, i.lat])) },
            );
          });
        });
      } catch (e) {
        console.log(e);
      }
    };

    const open = async (approveNo: String) => {
      console.log('open', approveNo);

      const res = await request.post(createApiUrl('/newlinkSass/quota/oil-supplement/detail'), { approveNo });
      console.log(res);
      if (res.code !== 200) return message.error(res.message);
      detailData.value = res.data || {};

      drawMap();
    };
    return {
      visible,

      detailData,
      tableColumns,
      onCancel,
      open,
    };
  },
});
